export function toJson(data, cols = 3, schema) {
    const arr = data.split('\n').filter(v => v);
    const arr1 = [];
    for (let i = 0; i < (arr.length - 1) / cols; i++) {
        const field = arr.slice(i * cols, cols * (i + 1));
        const objItem = createObject(field, schema.properties)
        arr1.push(objItem)
    }

    return flatToNested(arr1)

}

function flatToNested(arr) {
    const nestedArray = [];
    let currentObject = null;

    function addToNested(currentArray, remainingArray) {
        while (remainingArray.length > 0) {
            const item = remainingArray.shift();

            if (item.name === "{") {
                const nested = [];
                currentObject.properties = nested;
                addToNested(nested, remainingArray);
            } else if (item.name === "}") {
                return;
            } else {
                currentObject = {...item};
                currentArray.push(currentObject);
            }
        }
    }

    addToNested(nestedArray, arr);
    return nestedArray;
}

function createObject(field, schemaProperties) {
    const collectedField = {};
    const keys = {
        0: 'name',
        1: 'label',
        2: 'properties',
        3: 'description'
    }
    field.forEach((item, i) => {
        if (i === 2) {
            const properties = item.split(', ');
            if (properties.length) {
                properties.forEach(property => {
                    const delimited = property.split(':');
                    const key = delimited[0];
                    const schemaProperty = schemaProperties.find(v => v.name === key)

                    if (!schemaProperty) return;

                    let value = delimited[1]?.replace(/(\r\n|\n|\r)/gm, "");

                    if (schemaProperty.type === 'bool') {
                        value = Boolean(value === 'true');
                    }

                    if (schemaProperty.type === 'string' && schemaProperty.isArray) {
                        value = value.split(',')
                    }

                    collectedField[key] = value
                })
            }
        } else {
            collectedField[keys[i]] = item.replace(/(\r\n|\n|\r)/gm, "");
        }
    })
    return collectedField;
}
